import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/algolia': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M229.3 182.6c49.2 0 89.2 39.9 89.2 89.2s-39.9 89.2-89.2 89.2-89.2-39.9-89.2-89.2 39.9-89.2 89.2-89.2zM292 239.2c1.3-0.7 1.8-2.4 1.1-3.7-12.2-21.4-34.9-36.1-61.1-37.1-1.4-0.1-2.7 1.1-2.7 2.6v66.5c0 1.9 2 3.2 3.8 2.3zM389.1 32c32.5 0 58.9 26.4 58.8 58.9v330.2c0 32.5-26.3 58.9-58.9 58.9h-330.1c-32.5 0-58.9-26.4-58.9-59v-330.1c0-32.5 26.4-58.9 58.9-58.9h330.2zM186.5 116.7h0.1v15.8c0 1.7 1.7 3 3.4 2.5 12.7-3.7 25.9-5.5 39.4-5.5 13 0 25.8 1.7 38.1 5.1 1.6 0.5 3.3-0.7 3.3-2.5v-15.4c0-10.8-8.7-19.5-19.5-19.5h-45.3c-10.8 0-19.5 8.7-19.5 19.5zM102.1 153.7c-7.6 7.6-7.6 19.9 0 27.4l7.7 7.7c1.1 1.2 3 1 4-0.3 4.4-6.1 9.4-12 14.8-17.4 5.5-5.5 11.4-10.4 17.6-14.9 1.3-1 1.4-2.9 0.3-4l-7.7-7.7c-7.6-7.6-19.9-7.6-27.5 0zM229.3 398.5c69.9 0 126.6-56.8 126.6-126.6 0-70-56.6-126.6-126.6-126.6-69.9 0-126.6 56.7-126.6 126.6 0 69.9 56.6 126.6 126.6 126.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/algolia.js
// module id = 698
// module chunks = 0